const rawBaseUrl = import.meta.env.VITE_ASSETS_URL?.trim() || '/assets/'

function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
}

const baseUrl = normalizeBaseUrl(rawBaseUrl)

export function assetUrl(...parts: string[]): string {
  const suffix = parts.map((part) => part.replace(/^\/+|\/+$/g, '')).filter(Boolean).join('/')
  return `${baseUrl}${suffix}`
}

export function cssUrl(...parts: string[]): string {
  return `url("${assetUrl(...parts)}")`
}
